<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {

		}
	}
</script>

<style>
	html,
	body {
		margin: 0;
		padding: 0;
		background-color: black;
		width: 1920px;
		overflow-x: hidden;
	}
</style>